var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{class:['list-minimal', _vm.type]},_vm._l((_vm.items),function(item,i){return _c('li',{key:i,class:[
      'list-minimal-item',
      { mine: !_vm.isTrainer || (_vm.isTrainer && item.trainer_id !== '0') },
      { selected: _vm.isSelected(item) } ],on:{"click":function($event){return _vm.handleClick(item, i)}}},[(_vm.showThumbnail && _vm.thumbnailPhoto)?_c('BaseThumbnail',{attrs:{"image":_vm.thumbnailPhoto}}):_vm._e(),_c('span',{class:[
        'list-minimal-item-title',
        {
          newCircuit:
            (item && item.newCircuit && _vm.selectedCircuit.label === '') ||
            (_vm.selectedCircuit &&
              !_vm.selectedCircuit.newCircuit &&
              item &&
              item.newCircuit) ||
            (item && item.newCircuit && _vm.selectedIndex !== 0),
        } ]},[_vm._v(" "+_vm._s(!item.newCircuit ? item.label : _vm.selectedIndex === 0 && _vm.selectedCircuit && _vm.selectedCircuit.label !== '' && _vm.selectedCircuit && _vm.selectedCircuit.newCircuit ? _vm.selectedCircuit.label : 'New Circuit')+" ")]),(_vm.showIcon)?_c('img',{attrs:{"src":require("@assets/images/icon-chevron-right.svg")}}):_vm._e()],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }